export default __webpack_public_path__ + "static/galleon-3df3bb550f56cfcd835b18bd96158382.png";